module.exports = __webpack_public_path__ + "img/pleisure_headerimage.b463f2f9.jpg";